import React from 'react'
import FormSection from '../../molecules/FormSection/FormSection'
import ProductCard, { Variant } from '../../molecules/ProductCard/ProductCard'
import { Content } from './ProductSelectionForm.styles'

type Product = {
  title: string
  description: string[]
  price?: string
  buttonLabel: string
  selected: boolean
  variant?: Variant
  id: string
}

export type ProductSelectionFormProps = {
  onSelect: (product: Product) => void
  title: string
  products: Product[]
}

const ProductSelectionForm: React.FunctionComponent<ProductSelectionFormProps> = ({ title, onSelect, products }) => (
  <FormSection title={title}>
    <Content>
      {products.map(product => (
        <ProductCard key={product.id} {...product} onClick={() => onSelect(product)} />
      ))}
    </Content>
  </FormSection>
)

export default ProductSelectionForm
